import { GroupWidget } from '@/Reservations/Search/GroupWidget'
import {
  PrivateEventsOtherVenuesAvailability,
  type PrivateEventsOtherVenuesAvailabilityProps,
} from '../PrivateEventsOtherVenuesAvailability'

interface PrivateEventsGroupWidgetProps extends PrivateEventsOtherVenuesAvailabilityProps {}

export function PrivateEventsGroupWidget(props: PrivateEventsGroupWidgetProps) {
  return (
    <GroupWidget>
      <PrivateEventsOtherVenuesAvailability {...props} direction="column" showNextAvailableDay />
    </GroupWidget>
  )
}
